<template>
  <div>
    <div class="row mt-1 ml-2">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-history text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Historial de Contrato
        </span>
      </div>
    </div>
    <custom-result-not-found
      v-if="items.length === 0"
      text="No cuenta con contrato(s) en sistema."
    />
    <div v-for="(item, index) in items" :key="index">
      <custom-callout
        class-main="mt-3 ml-4"
        :has-border="false"
        :has-gradient="false"
        :has-toggle="false"
      >
        <div class="row mr-md-0 ml-n0 ml-md-n4 ml-0">
          <div class="col-12 col-md-1 my-2">
            <div class="color-gray-6 font-14">Año Fiscal:</div>
            <div class="color-black font-16">
              {{ item.academicYear | empty }}
            </div>
          </div>
          <div class="col-12 col-md-2 my-2">
            <div class="color-gray-6 font-14">Proveedor:</div>
            <div class="color-black font-16">
              {{ item.companyName | empty }}
            </div>
          </div>
          <div class="col-12 col-md-2 my-2">
            <div class="color-gray-6 font-14">Especialista:</div>
            <div class="color-black font-16">
              {{ specialistOrAssistantNames(item) | empty }}
            </div>
          </div>
          <div class="col-12 col-md-2 my-2">
            <div class="color-gray-6 font-14">Número de Contrato:</div>
            <div class="color-black font-16">
              {{ item.contractNumber | empty }}
            </div>
          </div>
          <div class="col-12 col-md-2 my-2">
            <div class="color-gray-6 font-14">Estatus:</div>
            <div class="color-black font-16">
              {{ item.contractStatusName | empty }}
            </div>
          </div>
          <div class="col-12 col-md-2 my-2">
            <div class="color-gray-6 font-14">Inicio de Contrato:</div>
            <div class="color-black font-16">
              {{ item.contractServiceStartDate | date('DD/MM/YYYY') }}
            </div>
          </div>
          <div class="col-12 col-md text-sm-right mt-3 mt-sm-1">
            <action-button
              i="fas fa-print pl-2"
              variant="success"
              @click="$emit('on-print', item)"
            />
          </div>
        </div>
      </custom-callout>
    </div>
    <pagination
      v-if="showServiceContractPagination"
      :data="pagination"
      show-text
      @pagination-go-page="goToPageHandler($event)"
    />
  </div>
</template>

<script>
import CustomResultNotFound from 'custom-result-not-found';
import CustomCallout from 'custom-callout';
import Pagination from 'pagination';
import ActionButton from 'ActionButton';

export default {
  name: 'ContractHistory',
  components: {
    CustomResultNotFound,
    CustomCallout,
    Pagination,
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    specialistOrAssistantNames() {
      return (item) => {
        return item.specialistOrAssistantList?.length
          ? item.specialistOrAssistantList
              .map((x) => this.$options.filters.capitalize(x.name))
              .join(', ')
          : null;
      };
    },
    showServiceContractPagination() {
      return this.pagination.count > 0 && this.pagination.pageCount > 1;
    },
  },
  methods: {
    async goToPageHandler(page) {
      this.$emit('on-go-to-page', page);
    },
  },
};
</script>
<style lang="scss">
.custom-col-md-2 {
  flex: 0 0 11.66666667%;
  max-width: 11.66666667%;
}
.custom-col-md-1 {
  flex: 0 0 10.33333333%;
  max-width: 10.33333333%;
}
@media screen and (max-width: 768px) {
  .custom-col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .custom-col-md-1 {
    flex: 0 0 15.33333333%;
    max-width: 15.33333333%;
  }
}
</style>
